export enum SizeBytes {
  Megabyte = 1048576,       // 1MB
  Gigabyte = 1073741824,    // 1GB
  Terabyte = 1099511627776  // 1TB
}
